exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "tr.selected[data-v-70c9c87c] {\n  background-color: #1890ff1c !important;\n}\n.a-button-success[data-v-70c9c87c] {\n  background-color: #70e0a5;\n}", ""]);

// exports
